import * as React from "react";
import {
  Card, CardActionArea,
  CardContent,
  createStyles,
  Grid,
  Theme,
  Typography,
  withStyles,
  WithStyles
} from "@material-ui/core";
import {inject, observer} from "mobx-react";
import User from "../../model/User";
import {isoToLocalDate} from "../../stores/StoreUtilities";
import TitleButton from "../../components/TitleButton";
import ControlTower, {Routes} from "../../components/ControlTower";
import { Link } from '@reach/router'
import {format} from "date-fns";

const styles = (theme: Theme) => createStyles({
  card: {
    width: '100%',
    height: 100,
    padding: 0
  },
  content: {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    padding: "5px 10px",
    display: "flex"
  },
  title: {
    fontSize: 16,
    fontWeight: 800,
    maxHeight: 24,
    overflow: "hidden",
  },
  titleButtons: {
    textAlign: "right",
    marginBottom: 4
  },
  owner: {
    fontSize: 14,
    fontWeight: 400,
  },
  details: {
    fontSize: 14,
    fontWeight: 400,
    maxHeight: 24,
    overflow: "hidden",
  },
  accountName: {
    color: theme.palette.secondary.main,
    fontSize: 14,
    fontWeight: 400,
    textAlign: "left",
    maxHeight: 20
  },
  right: {
    color: theme.palette.text.primary,
    fontSize: 14,
    fontWeight: 400,
    textAlign: "right"
  },
  actionArea: {
    color: theme.palette.secondary.main
  },
  link: {
    color: theme.palette.secondary.main,
    textDecoration: "none"
  }
})

interface IUserCardProps {
  user: User
  onCardAction?: any
}

@inject('user')
@observer
class UserCard extends React.Component<WithStyles<typeof styles> & IUserCardProps> {

  render() {
    const { classes, user, onCardAction } = this.props
    const status = user.userStatus.toString()
    const accountName = user.account ? user.account.name : ""
    const createdAt = format(isoToLocalDate(user.createdAt), 'M/d/yyyy')

    return (
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          <Grid container justify={'space-between'} direction="column">
            <Grid container justify={'space-between'} direction="row">
              <Grid item xs={8}>
                {onCardAction &&
                <CardActionArea onClick={this.onCardAction} className={classes.actionArea}>
                  <Typography className={classes.title}>
                    {user.lastName}, {user.firstName}
                  </Typography>
                </CardActionArea>
                }
                {!onCardAction &&
                  <Typography className={classes.title}>
                    {user.lastName}, {user.firstName}
                  </Typography>
                }
              </Grid>
              <Grid item xs={4}>
                <Typography className={classes.titleButtons}>
                  <TitleButton title="Edit" variant="secondary" onClick={this.onEdit}/>
                </Typography>
              </Grid>
            </Grid>
            <Grid container justify={'space-between'} direction="row">
              <Grid item xs={8}>
                {accountName &&
                  <Link to={`${Routes.account}/${user.accountId}/people`} className={classes.link}>
                    <Typography className={classes.accountName}>
                      {accountName}
                    </Typography>
                  </Link>
                }
              </Grid>
              <Grid item xs={4}>
                <Typography className={classes.right}>
                  {createdAt}
                </Typography>
              </Grid>
            </Grid>
            <Grid container justify={'space-between'} direction="row">
              <Grid item xs={8}>
                <Typography className={classes.details}>
                  {user.jobTitle}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography className={classes.right}>
                  {user.role}
                </Typography>
              </Grid>
            </Grid>
            {/*<Grid item>*/}
            {/*  <Typography className={classes.details}>*/}
            {/*    {user.email}*/}
            {/*  </Typography>*/}
            {/*</Grid>*/}
            <Grid container direction="row">
              <Grid item xs={6}>
                <Typography className={classes.details}>
                  {user.email}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.right}>
                  {status}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    )
  }

  onEdit = () => {
    const { user } = this.props
    if (ControlTower.currentRoute.startsWith(Routes.people)) {
      ControlTower.route(`${Routes.account}/${user.accountId}/userEdit/${user.id}?ret=${Routes.people}`)
    } else {
      ControlTower.route(`${Routes.account}/${user.accountId}/userEdit/${user.id}`)
    }
  }

  onCardAction = () => {
    if (this.props.onCardAction) {
      this.props.onCardAction(this.props.user)
    }
  }

}

export default withStyles(styles)(UserCard)
